export default {
  name: 'correspondence-distribute',
  data: function data() {
    return {
      form: {
        express: undefined,
        codes: undefined
      },
      list: [],
      loading: false
    };
  },
  methods: {
    toPrint: function toPrint() {}
  },
  created: function created() {}
};